/**
 * What Nira does with what you upload, said the same way wherever a document is dropped or kept.
 * Each clause is a row of the trust centre's "Your documents in Nira" (/trust/data-handling).
 * Deletion removes the data from the account at once; stored files are tagged and a storage lifecycle
 * rule erases them (and old versions) within 30 days; debugging traces expire within 60 days.
 * /privacy (SitePrivacy), /your-documents and the pricing FAQ say the same; change them together.
 */
/** Nira's own public page on it (the site's /your-documents, served in the app too). */
export const PRIVACY_URL = "/your-documents"

export const PRIVACY_POINTS = [
  { k: "Never used to train a model", v: "Not ours, not anyone else's. There is no setting that turns this on." },
  { k: "Used only for your reading", v: "The document is read for the reading you asked for, and your questions in its workspace. Nothing else." },
  { k: "Yours to delete", v: "Delete the workspace and its documents and readings go from your account at once. Copies are erased from our systems within 30 days, and AI debugging traces within 60." },
] as const

export const PRIVACY_LINE = "Never used to train a model, and used only for your reading, under the DPDP Act, 2023."
